const ITEMS = [
  "Vista para a Pedra do Baú",
  "Serra da Mantiqueira",
  "Lareira & ofurô",
  "Piscinas climatizadas",
  "Saunas privativas",
  "Santo Antônio do Pinhal",
];

const Drop = () => (
  <svg viewBox="0 0 12 28" className="h-7 w-3 shrink-0" aria-hidden="true">
    <ellipse cx="6" cy="8" rx="5" ry="7.5" fill="#7ab51d" />
    <line x1="6" y1="14" x2="6" y2="28" stroke="#7ab51d" strokeWidth="1.2" />
  </svg>
);

export const Marquee = () => (
  <div data-testid="marquee" className="marquee-wrap overflow-hidden border-y border-[#2c4a3b] bg-[#1a382b] py-7 text-[#f3efe4]">
    <div className="marquee-track flex w-max items-center">
      {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="flex items-center gap-10 pr-10 text-2xl tracking-tight sm:text-4xl">
          <span className={i % 2 ? "italic text-[#c8e39a]" : ""}>{t}</span>
          <Drop />
        </span>
      ))}
    </div>
  </div>
);
